import { put, select } from 'redux-saga/effects';
import {
  quizLaunchedAtSet,
  selectActiveQuizId,
  selectActiveQuizLaunchedAt,
} from 'features/quizzes/quizzesSlice';

export function* onQuizzesReceivedSaga() {
  const activeQuizId: string | null = yield select(selectActiveQuizId);
  const launchedAt: number | null = yield select(selectActiveQuizLaunchedAt);

  // Set launch timestamp if there's an active quiz and no timestamp set yet
  // This handles the reconnection case
  if (activeQuizId && !launchedAt) {
    yield put(quizLaunchedAtSet(Date.now()));
  }
}
